'use client';

import * as React from 'react';
import { useAppSelector } from '@/store/hooks';
import { getDrawerContent } from '@/store/reducers/drawer-content-slice';
import { OperatorCfAccount } from '@alien-platform/bo-sdk';
import { MethodResponse, PaginatedResponse } from '@alien-platform/bo-sdk-v2';
import { CircularProgress, Divider } from '@mui/material';
import { Box, Stack } from '@mui/system';

import { DetailsTable } from '@/components/core/details-table';
import { DetailsTableItem } from '@/components/core/details-table-item';

export function DetailsTab(): React.JSX.Element {
  const { CF_ACCOUNT_DETAILS } = useAppSelector(getDrawerContent);
  const [cfAccountData, setCfAccountData] = React.useState<OperatorCfAccount>();

  const fetchAccountData = async (): Promise<void> => {
    try {
      const response = await fetch(`/api/devops/cf-accounts/list`, {
        method: 'post',
        body: JSON.stringify({ cfAccountCode: CF_ACCOUNT_DETAILS }),
      });
      const result: MethodResponse<PaginatedResponse<OperatorCfAccount>> = await response.json();
      if (response.ok && result.success && result.data) {
        setCfAccountData(result.data?.items[0]);
      }
    } catch (e) {
      // empty block
    }
  };

  React.useEffect(() => {
    void fetchAccountData();
  }, []);

  return (
    <Stack direction="column">
      {!cfAccountData ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
          <CircularProgress color="primary" size={38} />
        </Box>
      ) : (
        <></>
        // <DetailsTable
        //   divider={<Divider />}
        //   sx={{ '--PropertyItem-padding': '16px' }}
        //   data={cfAccountData}
        //   paths={['domainName', 'opId', 'opTitle', 'cfZoneNameServers']}
        // >
        //   {/* {(
        //     Object.entries(cfAccountData).map(([key, value]) => ({ key, value })) satisfies {
        //       key: string;
        //       value: React.ReactNode;
        //     }[]
        //   ).map(
        //     (item): React.JSX.Element => (
        //       <DetailsTableItem key={item.key} name={item.key} value={item.value} />
        //     )
        //   )} */}
        // </DetailsTable>
      )}
    </Stack>
  );
}
